export const SELF_PRIVILEGE_CHANGE_BLOCKED_MESSAGE =
    'You cannot change your own role or privileges. Contact another administrator if access changes are needed.';

export function getSelfPrivilegeChangeState({
    mode,
    draft,
    targetUserId,
    currentUserId,
    originalGlobalRole,
    originalSuspended,
}) {
    const isSelfUser =
        mode === 'edit' &&
        Boolean(targetUserId && currentUserId && targetUserId === currentUserId);

    if (!isSelfUser) {
        return {
            isSelfUser: false,
            isChangingOwnRole: false,
            isChangingOwnSuspended: false,
            isBlockedSelfPrivilegeSave: false,
        };
    }

    const isChangingOwnRole =
        Object.prototype.hasOwnProperty.call(draft || {}, 'global_role') &&
        draft.global_role !== originalGlobalRole;

    const isChangingOwnSuspended =
        Object.prototype.hasOwnProperty.call(draft || {}, 'suspended') &&
        draft.suspended !== originalSuspended;

    return {
        isSelfUser,
        isChangingOwnRole,
        isChangingOwnSuspended,
        isBlockedSelfPrivilegeSave: isChangingOwnRole || isChangingOwnSuspended,
    };
}

export function isAttemptingSelfPrivilegeChange(params) {
    return getSelfPrivilegeChangeState(params).isBlockedSelfPrivilegeSave;
}
